<template>
  <div class="bg-gray rounded p-2">
    <div class="bg-white rounded p-3">
      <div class="row">
        <div class="col-12">
          <span class="title d-flex align-items-center">
            <div class="circle-icon d-flex mr-2">
              <span class="fa-stack fa-1x">
                <i class="fas fa-circle fa-stack-2x text-white" />
                <i class="fas fa-flag fa-stack-1x text-orange" />
              </span>
            </div>
            <span>Asignación de Maestro</span>
          </span>
        </div>

        <div class="col-12">
          <div class="pt-3 px-3">
            <ValidationObserver
              ref="form"
              tag="div"
              class="row justify-content-end"
            >
              <div class="col-12 col-lg-4 pt-2 pt-0-lg">
                <ValidationProvider
                  v-slot="{ errors }"
                  mode="lazy"
                  rules="required"
                  :custom-messages="{
                    required: 'Favor seleccionar fecha de comienzo',
                  }"
                >
                  <CustomDatePicker
                    v-model="model.assignmentStartDate"
                    label="Fecha de Comienzo:"
                    regular-label
                    :error="errors[0]"
                    :custom-error-msg="errors[0]"
                    :min-date="minStartDate"
                    :disabled="readonly"
                  />
                </ValidationProvider>
              </div>

              <div class="col-12 col-lg-4 pt-2 pt-0-lg">
                <ValidationProvider
                  v-slot="{ errors }"
                  mode="lazy"
                  rules="required"
                  :custom-messages="{
                    required: 'Favor seleccionar un maestro',
                  }"
                >
                  <CustomDropDown
                    v-model="model.teacherId"
                    label="Nombre del Maestro:"
                    regular-label
                    :options="collections.teachers"
                    :disabled="readonly"
                    fieldkey="id"
                    fieldname="name"
                    :error="errors[0]"
                    :custom-error-msg="errors[0]"
                    placeholder="Seleccione"
                    @input="teacherChange()"
                  />
                </ValidationProvider>
              </div>

              <div
                v-if="hasAssistanceServiceInServiceResume"
                class="col-12 col-lg-4 pt-2 pt-0-lg"
              >
                <ValidationProvider
                  v-slot="{ errors }"
                  mode="lazy"
                  rules="required"
                  :custom-messages="{
                    required: 'Favor seleccionar nombre del asistente',
                  }"
                >
                  <CustomDropDown
                    v-model="model.assistantId"
                    label="Nombre del Asistente:"
                    regular-label
                    :options="collections.assistants"
                    fieldkey="id"
                    fieldname="name"
                    :error="errors[0]"
                    :custom-error-msg="errors[0]"
                    placeholder="Seleccione"
                  />
                </ValidationProvider>
              </div>
              <div class="col-12 col-lg-4 pt-2 pt-0-lg">
                <ValidationProvider
                  v-slot="{ errors }"
                  mode="lazy"
                  rules="required"
                  :custom-messages="{
                    required: 'Favor seleccionar una ubicación',
                  }"
                >
                  <CustomDropDown
                    v-model="model.placementId"
                    label="Lugar de Servicio:"
                    regular-label
                    :options="collections.placements"
                    :disabled="readonly || model.teacherId == null"
                    fieldkey="id"
                    fieldname="name"
                    :error="errors[0]"
                    :custom-error-msg="errors[0]"
                    placeholder="Seleccione"
                  />
                </ValidationProvider>
              </div>
              <div class="col-12 col-lg-4 pt-2 pt-0-lg" />

              <div class="col-12 col-lg-4 pt-2">
                <label />
                <div
                  class="mt-2 d-flex flex-column flex-lg-row justify-content-lg-end"
                >
                  <ActionButton
                    :text="readonly ? 'Cerrar' : 'Cancelar'"
                    variant="outline-danger"
                    i="fas fa-times-circle"
                    class="w-auto w-lg-0"
                    @click="cancel"
                  />
                  <div class="my-1 mx-1 my-lg-0 mx-lg-2" />
                  <ActionButton
                    v-if="!readonly"
                    text="Guardar"
                    variant="success"
                    i="fas fa-save"
                    class="w-auto w-lg-0"
                    @click="submit"
                  />
                </div>
              </div>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ActionButton from 'ActionButton';
import alert from '@/mixin/alert.mixin';
import CustomDatePicker from 'custom-date-picker';
import CustomDropDown from 'custom-drop-down';
import {
  getSpecialistBySpecialtyType,
  getEducativeServicePlacements,
  assignTeacher,
} from '@/services/tapRequest';

const initialModel = () => ({
  teacherId: null,
  assistantId: null,
  assignmentStartDate: null,
  placementId: null,
  activateAssistant: false,
});

const SPECIALTY_TYPES = {
  ServicioEducativo: 16,
  AsistenteDeServicio: 17,
};

export default {
  name: 'TeacherAssignment',
  components: {
    ActionButton,
    CustomDatePicker,
    CustomDropDown,
  },
  mixins: [alert],
  props: {
    maxStartDate: {
      type: [String, Date],
      default: () => new Date(),
    },
    minStartDate: {
      type: [String, Date],
      default: () => new Date(),
    },
    tapRequestId: {
      type: [Number, String],
      required: true,
    },
    existingData: {
      type: Object,
      default: null,
    },
    academicYearId: {
      type: [Number],
      required: true,
    },
    hasAssistanceServiceInServiceResume: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: initialModel(),
      collections: {
        teachers: [],
        assistants: [],
        placements: [],
      },
    };
  },
  methods: {
    async fillCollections() {
      await this.fillTeachers();
      await this.fillAssistants();
    },
    async fillTeachers() {
      await getSpecialistBySpecialtyType(
        this.academicYearId,
        this.companyId,
        SPECIALTY_TYPES.ServicioEducativo
      )
        .then((result) => {
          if (result.data) {
            this.collections.teachers = result.data;
          }
        })
        .catch((error) => {
          this.ShowToast('Error', error.response.data.message, 'error');
        });
    },
    async fillAssistants() {
      await getSpecialistBySpecialtyType(
        this.academicYearId,
        this.companyId,
        SPECIALTY_TYPES.AsistenteDeServicio
      )
        .then((result) => {
          if (result.data) {
            this.collections.assistants = result.data;
          }
        })
        .catch((error) => {
          this.ShowToast('Error', error.response.data.message, 'error');
        });
    },
    async fillPlacements() {
      await getEducativeServicePlacements(
        this.model.teacherId.id,
        this.academicYearId,
        this.companyId
      )
        .then((result) => {
          if (result.data) {
            this.collections.placements = result.data;
          }
        })
        .catch((error) => {
          this.ShowToast('Error', error.response.data.message, 'error');
        });
    },
    async teacherChange() {
      if (this.model.teacherId != null) {
        this.placementId = null;
        await this.fillPlacements();
      } else {
        this.placementId = null;
        this.collections.placements = [];
      }
    },
    cancel(emit = true) {
      this.model = initialModel();
      this.$refs['form']?.reset();
      if (emit) {
        this.$emit('cancel');
      }
    },
    async submit() {
      let valid = await this.$refs['form'].validate();
      if (valid) {
        let assignment = {
          tapRequestId: this.tapRequestId,
          teacherId: this.model.teacherId?.id,
          assistantId: this.model.assistantId?.id,
          assignmentStartDate: this.model.assignmentStartDate,
          placementId: this.model.placementId?.id,
          assignedProviderId: Number(this.companyId),
        };
        await assignTeacher(assignment)
          .then(() => {
            this.cancel(false);
            this.$emit('success');
          })
          .catch((err) => {
            this.ShowToast(
              'Error',
              err.response.data.message ??
                'Se ha producido un error al intentar asignar la solicitud.',
              'error'
            );
            this.$emit('cancel');
          });
      }
    },
  },
  computed: {
    companyId() {
      return this.userProfile.companyid;
    },
  },
  async mounted() {
    if (!this.readonly) {
      await this.fillCollections();
    }

    if (this.existingData.teacher) {
      this.model.teacherId = this.existingData.teacher;
      this.model.assignmentStartDate = this.existingData.assignmentStartDate;
      this.fillPlacements();
      this.model.placementId = this.existingData.placement;
      if (this.existingData.assistant) {
        this.model.assistantId = this.existingData.assistant;
        this.model.activateAssistant = true;
      }
    }
  },
};
</script>
